import {postData} from "./PostData";
import {global} from "./Global";

export const cartProduct = () => {
    window.cartItem = () => {
        return {
            cartItemKey: '',
            quantity: '',

            updateQuantity(mode) {
                document.getElementById('loader').style.display = 'flex';

                if ('increase' === mode) {
                    this.quantity++;
                }

                if ('decrease' === mode) {
                    this.quantity--;
                }

                const form = new FormData();

                form.append('action', 'update_quantity');
                form.append('cartItemKey', this.cartItemKey);
                form.append('quantity', this.quantity);
                form.append('_ajax_nonce', my_ajax_object.nonce);
                form.append('blocksToUpdate', global.getBlocksToUpdate());

                const params = new URLSearchParams(form);

                postData(my_ajax_object.ajax_url, params)
                    .then(response => {
                        document.getElementById('loader').style.display = 'none';

                        if (!response || response.error) {
                            return;
                        }

                        global.updateBlocks(response);
                    });
            },
            removeCartItem() {
                document.getElementById('loader').style.display = 'flex';

                const form = new FormData();

                form.append('action', 'remove_item_from_cart');
                form.append('cartItemKey', this.cartItemKey);
                form.append('_ajax_nonce', my_ajax_object.nonce);
                form.append('blocksToUpdate', global.getBlocksToUpdate());

                const params = new URLSearchParams(form);

                postData(my_ajax_object.ajax_url, params)
                    .then(response => {
                        document.getElementById('loader').style.display = 'none';

                        if (!response || response.error) {
                            return;
                        }

                        global.updateBlocks(response);
                    });
            },
            init(cartItemKey, quantity) {
                this.cartItemKey = cartItemKey;
                this.quantity = quantity;
            }
        }
    }
}
